import React from "react";
import "./index.css";
import "./logos.css";
import Icon from "nekrasovka-ui/Icons";
import IconsGroup from "components/IconsGroup";
import styled from "styled-components";

const ModalHeaderSection = styled.section`
  & {
    max-width: 1220px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding-top: 17.5px;

    @media (max-width: 1260px) {
      padding-right: 20px;
      padding-left: 20px;
    }

    @media (max-width: 568px) {
      & a svg {
        height: 50px;
      }
    }
  }
`;

const ModalContainer = styled.div`
  max-width: 100%;
  width: 100%;
  display: block;

  background: rgba(0, 0, 0, 0.85);
  position: absolute;
  margin: 0 auto;
  height: 100%;
  z-index: 11;
`;

const Logo = styled.div`
  & {
    display: flex;

    a svg {
      width: 170px;
      height: 54px;
    }

    @media (max-width: 768px) {
      a svg {
        width: 100px;
        height: 40px;
      }

      a:not(:last-child) {
        margin-right: 18px;
      }
    }

    @media (max-width: 568px) {
      width: 100%;
      justify-content: space-between;
      padding: 0;

      a {
        margin-right: 0 !important;

        svg {
          width: 87px;
          height: 31px;
          margin-right: 0 !important;
        }
      }
    }
  }
`;

export default ({ setIsModalOpened, width, data, loading }) => {
  return (
    <ModalContainer>
      <ModalHeaderSection>
        <div className="section__content" style={{ padding: "0" }}>
          <div className="section__item">
            <a href="/" className="header__logo">
              <Icon fill="#EDEEE9" icon="logoText" width={157} height={57} />
            </a>
          </div>
          <div className="section__item">
            <div className="icon-group">
              <button
                className="icon-group__item modal__close-button"
                onClick={() => setIsModalOpened(false)}
              >
                <Icon
                  icon="close"
                  fill="#EDEEE9"
                  height={width > 568 ? "30px" : "25px"}
                  width={width > 568 ? "30px" : "25px"}
                />
              </button>
            </div>
          </div>
        </div>
        <div className="section__content xl-hidden l-hidden m-hidden">
          <div
            className="section__item section__item--fullwidth"
            style={{ alignItems: "stretch" }}
          >
            <div className="list list--footer list--vertical list--no-header">
              <ul className="list__items menu--modal">
                <li className="list__item">
                  <a
                    href="https://nekrasovka.ru/articles/guest"
                    className="link link--menu"
                  >
                    Посетителям
                  </a>
                </li>
                <li className="list__item">
                  <a
                    href="https://nekrasovka.ru/articles/collegue"
                    className="link link--menu"
                  >
                    Коллегам
                  </a>
                </li>
                <li className="list__item">
                  <a
                    href="https://nekrasovka.ru/articles/library"
                    className="link link--menu"
                  >
                    О библиотеке
                  </a>
                </li>
                <li className="list__item">
                  <a
                    href="https://nekrasovka.ru/articles/education"
                    className="link link--menu"
                  >
                    Образование
                  </a>
                </li>
                <li className="list__item">
                  <a
                    href="https://biblioteka.nekrasovka.ru/addresses"
                    className="link link--menu"
                  >
                    Адреса
                  </a>
                </li>
                <li className="list__item">
                  <a
                    href="https://opac.nekrasovka.ru/vmk/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="link link--menu"
                  >
                    Каталог
                  </a>
                </li>
                <li className="list__item">
                  <a
                    href="https://nekrasovka.ru/afisha"
                    className="link link--menu"
                  >
                    Афиша
                  </a>
                </li>

                <li className="list__item">
                  <a
                    href="https://biblioteka.nekrasovka.ru/event"
                    className="link link--menu"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Проекты
                  </a>
                </li>
                <li className="list__item">
                  <a
                    href="https://nekrasovka.ru/clubs"
                    className="link link--menu"
                  >
                    Клубы
                  </a>
                </li>
                <li className="list__item">
                  <a
                    href="https://nekrasovka.ru/books"
                    className="link link--menu"
                  >
                    Журнал
                  </a>
                </li>
                <li className="list__item">
                  <a
                    href="https://electro.nekrasovka.ru"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="link link--menu"
                  >
                    Электронекрасовка
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        {loading && (
          <div className="section__content">
            <div className="section__item section__item--fullwidth">
              <div className="grid grid--accessibility">
                <div className="grid__row util--accessibility-column">
                  {data.map((item, key) => {
                    const { address, open, phone, mail, name } = item;

                    return (
                      <div
                        key={key}
                        className="grid__item grid__item-3 grid__item--footer"
                      >
                        <div className="list list--footer list--vertical">
                          <a
                            target="_blank"
                            rel="noopener noreferrer"
                            className="list__title"
                            href="https://biblioteka.nekrasovka.ru/rosha"
                          >
                            {name[0]}
                          </a>
                          <ul className="list__items">
                            <li className="list__item list__item--address">
                              {address[0]}
                            </li>
                          </ul>
                        </div>
                        <div className="list list--footer list--vertical">
                          <span className="list__title">Режим работы: </span>
                          <ul className="list__items">
                            {open.map((opened, openedIndex) => {
                              return (
                                <li key={openedIndex} className="list__item">
                                  {opened[0]}
                                </li>
                              );
                            })}
                            {!!phone && (
                              <li className="list__item">Тел.: {phone}</li>
                            )}
                            {!!mail && (
                              <li className="list__item">E-mail: {mail}</li>
                            )}
                          </ul>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="divider" />
        <div className="section__content">
          <div
            className="section__item section__item--fullwidth"
            style={{ alignItems: "stretch" }}
          >
            <div className="grid">
              <div className="grid__row">
                <div className="grid__item grid__item-4 grid__item--footer">
                  <div className="list list--footer list--vertical">
                    <a
                      href="https://nekrasovka.ru/articles/library"
                      className="link"
                    >
                      <span className="list__title text--uppercase">
                        О библиотеке
                      </span>
                    </a>
                    <ul className="list__items">
                      <li className="list__item">
                        <a
                          href="https://nekrasovka.ru/articles/library/collection"
                          className="link"
                        >
                          Фонды
                        </a>
                      </li>
                      <li className="list__item">
                        <a
                          href="https://nekrasovka.ru/articles/library/history"
                          className="link"
                        >
                          История
                        </a>
                      </li>
                      <li className="list__item">
                        <a
                          href="https://nekrasovka.ru/articles/library/nekrasov"
                          className="link"
                        >
                          Н.А. Некрасов
                        </a>
                      </li>
                      <li className="list__item">
                        <a
                          href="https://nekrasovka.ru/articles/library/services"
                          className="link"
                        >
                          Услуги
                        </a>
                      </li>
                      <li className="list__item">
                        <a
                          href="https://nekrasovka.ru/articles/library/management"
                          className="link"
                        >
                          Руководство
                        </a>
                      </li>
                      <li className="list__item">
                        <a
                          href="https://nekrasovka.ru/articles/library/organization"
                          className="link"
                        >
                          Структура и документы
                        </a>
                      </li>
                      <li className="list__item">
                        <a
                          href="https://nekrasovka.ru/articles/library/contacts"
                          className="link"
                        >
                          Как с нами связаться
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="grid__item grid__item-4 grid__item--footer">
                  <div className="list list--footer list--vertical">
                    <a
                      href="https://nekrasovka.ru/articles/guest"
                      className="link"
                    >
                      <span className="list__title text--uppercase">
                        Посетителям
                      </span>
                    </a>
                    <ul className="list__items">
                      <li className="list__item">
                        <a
                          href="https://nekrasovka.ru/articles/guest/rules"
                          className="link"
                        >
                          Правила библиотеки
                        </a>
                      </li>
                      <li className="list__item">
                        <a
                          href="https://nekrasovka.ru/articles/guest/account"
                          className="link"
                        >
                          Личный кабинет
                        </a>
                      </li>
                      <li className="list__item">
                        <a
                          href="https://nekrasovka.ru/articles/guest/resource"
                          className="link"
                        >
                          Электронные ресурсы
                        </a>
                      </li>
                      <li className="list__item">
                        <a
                          href="https://nekrasovka.ru/articles/guest/coworking"
                          className="link"
                        >
                          Пространства для чтения и работы
                        </a>
                      </li>
                      <li className="list__item">
                        <a
                          href="https://nekrasovka.ru/articles/guest/libraryservice"
                          className="link"
                        >
                          Помощь библиографа
                        </a>
                      </li>
                      <li className="list__item">
                        <a href="https://nekrasovka.ru/afisha" className="link">
                          Культурные события
                        </a>
                      </li>

                      <li className="list__item">
                        <a
                          href="https://nekrasovka.ru/articles/guest/faq"
                          className="link"
                        >
                          Ответы на вопросы
                        </a>
                      </li>
                      <li className="list__item">
                        <a
                          href="http://bus.gov.ru/pub/independentRating/list"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="link"
                        >
                          Оценка качества услуг (bus.gov.ru)
                        </a>
                      </li>
                      <li className="list__item">
                        <a
                          href="http://old.kultura.mos.ru/organizations/gbuk_gmoskvy_tsentralnaya_universalnaya_nauchnaya_biblioteka_imeni_nanekrasova.html"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="link"
                        >
                          Оценка качества услуг (mos.ru)
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="grid__item grid__item-4 grid__item--footer">
                  <div className="list list--footer list--vertical list--footer">
                    <a
                      href="https://nekrasovka.ru/articles/collegue"
                      className="link"
                    >
                      <span className="list__title text--uppercase">
                        Коллегам
                      </span>
                    </a>
                    <ul className="list__items">
                      <li className="list__item">
                        <a
                          href="https://nekrasovka.ru/articles/education"
                          className="link"
                        >
                          Образование
                        </a>
                      </li>
                      <li className="list__item">
                        <a
                          href="https://nekrasovka.ru/articles/collegue/events"
                          className="link"
                        >
                          События
                        </a>
                      </li>
                      <li className="list__item">
                        <a
                          href="https://nekrasovka.ru/articles/collegue/materials"
                          className="link"
                        >
                          Методические материалы
                        </a>
                      </li>
                      <li className="list__item">
                        <a
                          href="http://miscp.ru"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="link"
                        >
                          Исследования
                        </a>
                      </li>
                      <li className="list__item">
                        <a
                          href="https://nekrasovka.ru/articles/collegue/forum"
                          className="link"
                        >
                          Форум
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="grid__item grid__item-4 grid__item--footer m-hidden s-hidden xs-hidden">
                  <IconsGroup
                    isLabelNeeded={true}
                    iconsGroupStyle="flex-direction: column;align-items: flex-start; & span {color: #edeee9;};"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <Logo>
          <a
            href={"https://nekrasovka.ru/"}
            rel="noopener noreferrer"
            target="_blank"
            aria-label="Библиотека им. Н.А. Некрасова"
          >
            <Icon fill="#EDEEE9" icon={"logoFooterText"} />
          </a>
          <a
            href={"https://www.mos.ru/kultura/"}
            rel="noopener noreferrer"
            target="_blank"
            aria-label="Департамент культуры города Москвы"
          >
            <Icon fill="#EDEEE9" icon={"logoDepMos"} />
          </a>
          <a
            href={"https://bibliogorod.ru/"}
            rel="noopener noreferrer"
            target="_blank"
            aria-label="Библиотеки Москвы"
          >
            <Icon fill="#EDEEE9" icon={"logoBiblioText"} />
          </a>
        </Logo>
      </ModalHeaderSection>
    </ModalContainer>
  );
};



// WEBPACK FOOTER //
// ./src/components/MenuModal/index.js